export const DISCORD_INVITE_URL = "https://discord.gg/frygWw8S2v";
export const TWITTER_URL = "https://x.com/cedehub";
export const LINKEDIN_URL = "https://www.linkedin.com/company/cede-hub";
export const TELEGRAM_URL = "https://t.me/cede_hub_chat";
export const DISCORD_SUPPORT_URL = "https://discord.gg/eVksFrpn6b";

export const CEDE_STORE_URL = "https://cede.store/";
export const CEDE_STORE_WIDGET_DOCUMENTATION_URL = "https://docs.cede.store/widgets/installation";

// Cede Flow
export const CEDE_FLOW_DISCORD_URL = "https://discord.gg/ACu3BZVnT4";
export const CEDE_FLOW_X_URL = "https://x.com/cedeflow";
export const CEDE_FLOW_LINKEDIN_URL = "https://www.linkedin.com/company/cede-labs/";
export const CEDE_FLOW_DOCS_URL = "https://cedelabs.gitbook.io/cede-flow/";

// Cede Arena
export const CEDE_ARENA_DISCORD_URL = "https://discord.gg/guDyeDqrEa";
export const CEDE_ARENA_X_URL = "https://x.com/cedearena";
export const CEDE_ARENA_GUIDE_URL = "https://cede-labs.notion.site/Cede-Arena-Guide-36dc717c212b80819087e8e86dafbf8c";
